import React from 'react';
import {ModalBackdrop, ModalClose, ModalCntent} from './Modal.styles';

const Modal = ({
  closeBtn = true,
  onClose,
  children,
  width,
  height,
  padding,
  bgColor = '#fff',
  widthClass = '',
  heightClass = '',
  closeOnBackdropClick = false,
}) => {
  const handleBackdropClick = e => {
    if (e.target === e.currentTarget && onClose && closeOnBackdropClick) {
      onClose();
    }
  };

  const handleContentClick = e => {
    e.stopPropagation();
  };

  return (
    <React.Fragment>
      <ModalBackdrop onClick={handleBackdropClick} />
      <ModalCntent
        width={width}
        height={height}
        bgColor={bgColor}
        padding={padding}
        className={`${heightClass} ${widthClass}`}
        onClick={handleContentClick}
      >
        {closeBtn && <ModalClose onClick={onClose} />}
        {children}
      </ModalCntent>
    </React.Fragment>
  );
};

export default Modal;
